export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=53b6ee32"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/HighwaySection/Edit.vue?vue&type=template&id=53b6ee32
// module id = 2711
// module chunks = 31